(function () {
  var form = document.querySelector('.lab-reports-hero__form');
  if (!form) return;

  var input = form.querySelector('.lab-reports-hero__input');
  if (!input) return;

  function reset() {
    document.querySelectorAll('.coa-report, .coa-product, .coa-collection')
      .forEach(function (el) { el.style.display = ''; });
    document.querySelectorAll('details.coa-product[open]')
      .forEach(function (detail) { detail.open = false; });
  }

  function filter() {
    var queryText = input.value.toLowerCase().trim();
    if (!queryText) { reset(); return; }

    var firstMatch = null;

    document.querySelectorAll('.coa-collection').forEach(function (collection) {
      var collectionHasMatch = false;

      collection.querySelectorAll('.coa-product').forEach(function (product) {
        var productHasMatch = false;

        product.querySelectorAll('.coa-report').forEach(function (report) {
          var match = report.textContent.toLowerCase().indexOf(queryText) > -1;
          report.style.display = match ? '' : 'none';
          if (match) {
            productHasMatch = true;
            if (!firstMatch) firstMatch = product;
          }
        });

        product.style.display = productHasMatch ? '' : 'none';
        product.open = productHasMatch;
        if (productHasMatch) collectionHasMatch = true;
      });

      collection.style.display = collectionHasMatch ? '' : 'none';
    });

    if (firstMatch) {
      firstMatch.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    filter();
  });

  input.addEventListener('input', function () {
    if (!input.value.trim()) reset();
  });
})();
